import { IconButton, makeStyles } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import { Calendar, DateObject } from 'react-multi-date-picker';
import { datesAreOnSameDay, prettyDate } from "../../config/dateFormatting";
import useOnClickOutside from '../../hooks/useOutsideAlerter';

const useStyles = makeStyles((theme: any) => ({
    container: {
        display: 'grid',
        justifyContent: 'start',
        alignItems: 'center',
        gridTemplateColumns: '50px 250px 50px',
        height: '60px',
        fontSize: 24,
        '& > *': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '100%'
        },
    },
    todayTitle:{
        fontWeight: 'bold',
        paddingRight: 10
    },
    primary: {
        color: theme.palette.primary.main
    },
    secondary: {
        color: theme.palette.secondary.main
    },
    calendar: {
        border: "1px solid black"
    },
    calendarContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: "absolute",
        width: 350,
        "& > *": {
            maxWidth: "300px !important"
        }
    },
    todayLink: {
        color: theme.palette.primary.main,
        display: "flex",
        width: 350,
        justifyContent: "center",
        marginTop: -10,
        "&:hover": {
            textDecoration: "underline",
            cursor: "pointer"
        }
    }
}));

interface Props { 
    date: Date;
    setDate: React.Dispatch<React.SetStateAction<Date>>;
}

export const DateCarousel: React.FC<Props> = ({date, setDate}) => {
    // Stling
    const classes = useStyles();

    // State
    const today = new Date()
    const [isCalendarPicking, setIsCalendarPicking] = useState(false)

    // Click outside calendar
    const ref = useRef(null)

    const handleClickOutside = () => {
        setIsCalendarPicking(false)
    }

    useOnClickOutside(ref, handleClickOutside)

    function decreaseDate(){
        if(date.getDay()=== 1){
            setDate(new Date(date.getTime() - 3 * (1000 * 60 * 60 * 24)))
        } else {
            setDate(new Date(date.getTime() - (1000 * 60 * 60 * 24)))
        }
    }

    function increaseDate(){
        if(date.getDay()=== 5){
            setDate(new Date(date.getTime() + 3 * (1000 * 60 * 60 * 24)))
        } else {
            setDate(new Date(date.getTime() + (1000 * 60 * 60 * 24)))
        }
    }

    const toDate = (dateObject: DateObject) : Date => {
        return dateObject.toDate()
    }

    function handleChange(e: any) {
        if(e instanceof DateObject){
            setDate(toDate(e));
        }
    }

    useEffect(() => {
        setIsCalendarPicking(false)
    },[date])

    return (
        <div ref={ref}>
            <div className={classes.container}>
                <IconButton onClick={() => decreaseDate()}>
                    <MdArrowBackIos className={classes.primary}/>
                </IconButton>
                <div onClick={() => setIsCalendarPicking(!isCalendarPicking)} style={{cursor: "pointer"}}>
                    <div>
                        {datesAreOnSameDay(date,today) ? <div style={{fontWeight: 'bold'}}>{prettyDate(date,false,true)} </div> : <div>{prettyDate(date,false,true)} </div>}
                    </div>
                </div>
                <IconButton onClick={() => increaseDate()}>
                    <MdArrowForwardIos className={classes.secondary}/>
                </IconButton>
            </div>
            <div className={classes.todayLink} onClick={() => {setDate(new Date())}}>
                Today
            </div>
            {
                isCalendarPicking &&
                <div className={classes.calendarContainer}>
                    <Calendar
                        currentDate={new DateObject()}
                        multiple={false}
                        value={date} 
                        onChange={handleChange}
                        weekStartDayIndex={1}
                        showOtherDays={false}
                        className={classes.calendar}
                        mapDays={({ date }) => {
                            // Styling of today
                            if(datesAreOnSameDay(date.toDate(), new DateObject().toDate())){
                                return {
                                    style: { background: "#6178ed7c", color:'white' },
                                    id: "today-calendar-date",
                                    className: "calendar-date",
                                }
                            }

                            // Styling of weekends
                            let isWeekend = [0, 6].includes(date.weekDay.index)
                            if (isWeekend) return {
                                disabled: true,
                                style: { color: "#ccc" },
                                className: "calendar-date",
                                onClick: () => alert("Weekends are disabled")
                            }

                            // Identifiers for date spans
                            return{
                                className: "calendar-date",
                            }
                        }}
                    />
                </div>
            }
        </div>
    );
}